import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class DeliverySiteOnboardingResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                id: '1',
                requester: 'requester@sapore.com',
                request_timestamp: '2025-01-01T10:00:00Z',
                state: 'PENDING',
                customer: {
                    code: '001',
                    fantasy_name: 'Cliente',
                    business_name: 'Cliente SA',
                    taxpayer_identification_number: '30700111223'
                },
                request: {
                    id: '2',
                    name: 'Site Name',
                    location: {
                        address: 'Address 123',
                        city: 'CABA',
                        postal_code: '1425',
                        latitude: '-34.6037',
                        longitude: '-58.3816',
                    },
                    jurisdiction: 'Capital Federal',
                    zone: 'CABA',
                    preferred_delivery_time_range: 'de 8 a 12',
                    exceptional_frequency: ['LUNES']
                },
                location: {
                    address: 'Address 123',
                    city: 'CABA',
                    postal_code: '1425',
                    latitude: '-34.6037',
                    longitude: '-58.3816'
                },
                authorizations: {
                    tax_authorization: null,
                    logistics_authorization: null
                },
            },
            errors: []
        };
    }

    deliverySiteOnboarding() {
        const deliverySiteOnboarding = this.content();
        return {
            id: deliverySiteOnboarding.id,
            requester: deliverySiteOnboarding.requester,
            requestTimestamp: deliverySiteOnboarding.request_timestamp,
            state: deliverySiteOnboarding.state,
            customer: this._customerFrom(deliverySiteOnboarding.customer),
            request: this._requestFrom(deliverySiteOnboarding.request),
            location: this._locationFrom(deliverySiteOnboarding.location),
            authorizations: this._authorizationsFrom(deliverySiteOnboarding.authorizations),
        };
    }

    _customerFrom(rawCustomer) {
        return {
            code: rawCustomer.code,
            fantasyName: rawCustomer.fantasy_name,
            businessName: rawCustomer.business_name,
            taxpayerIdentificationNumber: rawCustomer.taxpayer_identification_number
        };
    }

    _requestFrom(rawRequest) {
        return {
            id: rawRequest.id,
            name: rawRequest.name,
            address: rawRequest.location.address,
            city: rawRequest.location.city,
            postalCode: rawRequest.location.postal_code,
            jurisdiction: rawRequest.jurisdiction,
            zone: rawRequest.zone,
            preferredDeliveryTimeRange: rawRequest.preferred_delivery_time_range,
            exceptionalFrequency: rawRequest.exceptional_frequency || [],
        };
    }

    _locationFrom(rawLocation) {
        if (!rawLocation) return null;
        return {
            address: rawLocation.address,
            city: rawLocation.city,
            postalCode: rawLocation.postal_code,
            latitude: rawLocation.latitude,
            longitude: rawLocation.longitude,
        };
    }

    _authorizationsFrom(rawAuthorizations) {
        if (!rawAuthorizations) {
            return {
                taxAuthorizationState: null,
                logisticsAuthorizationState: null,
            };
        }
        return {
            taxAuthorizationState: rawAuthorizations.tax_authorization,
            logisticsAuthorizationState: rawAuthorizations.logistics_authorization,
        };
    }
}
